import type { ReactNode } from 'react'

export function AuthCard({ title, children, footer }: { title?: string; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-6 p-6">
      <div className="flex items-center gap-2 text-lg font-semibold">
        <span className="font-bold text-white">1</span> One Deployment
      </div>
      <div className="w-full max-w-sm rounded-lg border border-border bg-surface-2 p-5">
        {title && <h1 className="mb-4 text-base font-semibold">{title}</h1>}
        {children}
      </div>
      {footer && <div className="text-xs text-fg-subtle">{footer}</div>}
    </div>
  )
}

export function FormError({ children }: { children: ReactNode }) {
  if (!children) return null
  return (
    <div role="alert" className="mb-3 rounded-md border border-err/30 bg-err/5 px-2.5 py-2 text-xs text-err">
      {children}
    </div>
  )
}
